<template>
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1999 35.3998H15.3999H8.16227C6.4158 35.3998 5 33.984 5 32.2375V8.16227C5 6.4158 6.4158 5 8.16227 5H22.6376C24.3841 5 25.7999 6.4158 25.7999 8.16227V18.5999"
      :stroke="fill"
      stroke-width="1.20217"
    />
    <mask
      id="path-2-inside-1_290_7370"
      fill="white"
    >
      <rect
        x="7.20117"
        y="7.99976"
        width="15.9999"
        height="7.99995"
        rx="1.05409"
      />
    </mask>
    <rect
      x="7.20117"
      y="7.99976"
      width="15.9999"
      height="7.99995"
      rx="1.05409"
      fill="#D1D7DF"
      :stroke="fill"
      stroke-width="2.40434"
      mask="url(#path-2-inside-1_290_7370)"
    />
    <circle
      cx="25.8011"
      cy="27.4"
      r="8.99885"
      fill="white"
      :stroke="fill"
      stroke-width="1.20217"
    />
    <circle
      cx="9.40019"
      cy="20.6011"
      r="1.19999"
      :fill="fill"
    />
    <circle
      cx="9.40019"
      cy="25.4004"
      r="1.19999"
      :fill="fill"
    />
    <circle
      cx="9.40019"
      cy="30.2"
      r="1.19999"
      :fill="fill"
    />
    <circle
      cx="14.9998"
      cy="25.4004"
      r="1.19999"
      :fill="fill"
    />
    <circle
      cx="14.9998"
      cy="20.6011"
      r="1.19999"
      :fill="fill"
    />
    <circle
      cx="14.9998"
      cy="30.2"
      r="1.19999"
      :fill="fill"
    />
    <circle
      cx="22.2002"
      cy="24.5994"
      r="1.47294"
      :stroke="fill"
      stroke-width="1.05409"
    />
    <circle
      cx="29.4014"
      cy="30.1994"
      r="1.47294"
      :stroke="fill"
      stroke-width="1.05409"
    />
    <path
      d="M29.8007 23.4014L21.8008 31.4013"
      :stroke="fill"
      stroke-width="1.05409"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsVerticalsHomePersonalLoan'
})

defineProps({
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>
